<script>
import {mapActions} from "vuex";

export default {
  name: "uConnectPaymentStep",
  data() {
    return {
      stripe: "",
    }
  },
  mounted() {

    var uConnectRegistrationSession = localStorage.getItem("uConnectRegistrationKey");
    this.getUConnectSubscribeCheckout({
      params: {
        sessionId: uConnectRegistrationSession,
        userId: this.$store.state.uConnect.userId,
        email: this.$store.state.uConnect.email,
        subscriptionType: this.$store.state.uConnect.subscriptionType,
      },
      callback: this.joinUConnectLinkPaymentCallback
        });

  },
  methods: {
    ...mapActions("uConnect", ["getUConnectSubscribeCheckout", "getUConnectSubscriptionStatus"]),
    async initialize() {
      this.checkout = await this.stripe.initEmbeddedCheckout({
        clientSecret: this.clientSecret
      });
      this.checkout.mount("#checkoutUConnect");
      this.checkoutDisplayed = true;
    },
    joinUConnectLinkPaymentCallback(res) {

      if (res.data.code == 0) {
        this.stripe = Stripe(process.env.VUE_APP_STRIPE);
        this.checkoutDisplayed = true;
        this.clientSecret = res.data.data.clientSecret;
        this.initialize();
        this.loading = false;

      }else if (
        res.data.code == 90000 ||
        res.data.code == 90002 ||
        res.data.code == 90001) {
        this.$box.alert('', res.data.message ,'error');
        this.$router.push("/uconnect");
      }
    },
  }

}
</script>

<template>
  <div class="plan-selection">
    <el-row type="flex" justify="center" align="middle">
      <el-col :xs="24" :sm="20" :md="16" :lg="12" :xl="10">
        <el-card class="selection-card">
          <!-- Step Indicator Row -->
          <el-row type="flex" justify="center">
            <el-col :span="24">
              <div class="step-indicator">
                <div class="step-text">STEP 3 OF 3</div>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col id="checkoutUConnect" ref="checkoutUConnect">
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<style scoped lang="css">
.plan-selection {
  min-height: 100vh;
  padding: 20px;
  background-color: #f5f7fa;
}
.selection-card {
  margin-top: 20px;
  padding: 20px;
  background-color: #fff;
  border-radius: 5px;
}
.step-indicator {
  margin-bottom: 20px;
}
.step-text {
  font-size: 20px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/register/uConnectRegistration/steps/paymentSteps/uConnectPaymentStep.vue